import React, { useState, useEffect, useContext } from "react";
import Quilleditor from "../../Quilleditor/Quilleditor";
import "./Summary.scss";
import ResumeUseForm from "../../../hooks/editor/resumeUseForm";
import ResumeSubUseForm from "../../../hooks/editor/resumeSubUseForm";
import { ResumePopupContext } from "../../../Context/resumePopupContext";
import { useTranslation } from "react-i18next";
import InputEditable from "../../ContentEditable/InputEditable";
import Dragicon from "../../Dragicon/Dragicon";
import CarouselSlider from "../../Caurosel/Carousel";
import {
  userParticularGet,
  userUpdate,
} from "../../../Store/Actions/UserActions";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams, useRouteMatch } from "react-router";
import DeleteButton from "../../Buttons/ResumeDeleteButton/DeleteButton";
import ResumeButton from "../../Buttons/ResumeButton/ResumeButton";
import IconButton from "../../Buttons/IconButton/IconButton";
import EditorInput from "../../Inputs/EditorInput";

function Summary({
  resumeHandler,
  resumeUpdate,
  addResumeField,
  sectionId,
  resumeFields,
  showHideElements,
  setModalShow,
  styles,
  settings,
  resumeTitleHandler,
  handleEditorChange,
  resumeTitleRemove,
  dateHandler,
  deletePopupShow,
}) {
  const [t, i18n] = useTranslation("common");
  const { id } = useParams();
  const [show, setShow] = useState(true);
  const [suggestion, setSuggestion] = useState(false);

  const showSuggestion = () => {
    setSuggestion(!suggestion);
    setShow(!show);
  };

  const { showPopup, arrayIndex } = useContext(ResumePopupContext);

  const userInfo = useSelector((state) => state.particularuser.user);
  const dispatch = useDispatch();

  // useEffect(() => {
  // 	dispatch(userParticularGet(id, true));
  // }, [dispatch]);

  return (
    <>
      {resumeFields && (
        <>
          <div className={`card mb-4 section-card basic-scroll-${sectionId}`}>
            <div className="card-header d-flex justify-content-between align-items-center bg-white">
              <h4 className="card-title d-flex">
                <InputEditable
                  sectionId={sectionId}
                  resumeFields={resumeFields}
                  onBlur={resumeTitleHandler}
                  name="customTitle"
                  onRemove={resumeTitleRemove}
                />
              </h4>
              <div>
                {/* <button className="btn extrafieldbtn">
										<span className="showlable">Show Section</span>
										<span className="switchbtn">
											<input
											type="checkbox"
											id="switch"
											checked={resumeFields.show}
											onChange={handleShowSection}
											/>
											<label for="switch">Toggle</label>
										</span>
										</button> */}
                <ResumeButton
                  left
                  left_icon
                  primary
                  src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/trash.svg`}
                  alt="delete"
                  title="Delete"
                  className="mr-3"
                  onClick={() => deletePopupShow("layout", sectionId)}
                />
              </div>
            </div>

            <div className="card-body">
              {resumeFields &&
                resumeFields.data &&
                resumeFields.data.map((res, index) => (
                  <>
                    <div className="col-md-12 mb-3">
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <EditorInput
                            label={"Title"}
                            value={res.title}
                            name="title"
                            autoComplete="off"
                            className={`form-control  ${sectionId}focus${index}`}
                            onChange={(e) =>
                              resumeHandler(e, index, "basic", sectionId)
                            }
                            onBlur={resumeUpdate}
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          backgroundColor: "#edf0f1",
                          padding: "2px",
                          borderRadius: "6px",
                        }}
                      >
                        <Quilleditor
                          type="basic"
                          theme={"snow"}
                          inivalue={res?.description?.replace(/\n|\r/g, "")}
                          className={`${sectionId}focus${index}`}
                          current={index}
                          id={sectionId}
                          sectionId={sectionId}
                          placeholder="Whats the one thing that you want someone to remember to after reading your resume?"
                          setvalue={handleEditorChange}
                          onBlur={resumeUpdate}
                        />
                      </div>
                    </div>
                  </>
                ))}
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Summary;
